<template>
  <el-popover
    placement="bottom-end"
    v-model="showPopover"
    popper-class="popper-clear-style"
    trigger="click"
  >
    <div class="container">
      <div class="btn-contaniner">
        <div v-if="canDelete" class="pointer" @click.stop="$emit('clickdelete'); showPopover = false">
          刪除
        </div>
        <div v-else class="pointer" @click.stop="showImpeach">
          檢舉
        </div>
      </div>
    </div>
    <div class="tool-model" @click.stop="showPopover = false" />
    <button
      class="cirle-container"
      slot="reference"
      :style="{
        width,
        height,
      }"
      @click.stop
    >
      <fps-icon class="more-icon" type="more" size="24" />
    </button>
  </el-popover>
</template>
<script>
import impeach from '@/components/Impeach/index.js'
import { mapGetters } from 'vuex'
export default {
  name: 'SetFriend',
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    operateUuid: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '22px',
    },
    height: {
      type: String,
      default: '22px',
    },
    masterUuid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPopover: false,
    };
  },
  watch: {
    show(val) {
      this.showPopover = val
    },
    showPopover(val) {
      this.$emit('change', val)
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'adminUuid']),
    canDelete() {
      if (!this.userInfo) return false
      return [this.masterUuid, this.operateUuid, this.adminUuid].includes(this.userInfo.uuid)
    }
  },
  methods: {
    showImpeach() {
      this.showPopover = false
      if (this.userInfo) {
        impeach({
          reportedId: this.operateUuid,
        })
      } else {
        this.$util.Login()
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
  }
  .cirle-container {
    @include flex(center);

    .more-icon {
      color: $color-gray-2;
    }
  }
  .container {
    width: 88px;
    color: #333;
    font-size: 14px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 2px 4px 24px rgba(17, 17, 53, 0.0773601);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
    .btn-contaniner {
      background: #fff;
      padding: 8px;
      border-radius: 4px;
      div {
        width: 72px;
        height: 32px;
        line-height: 32px;
        text-align: left;
        border-radius: 4px;
        padding-left: 8px;
        &:hover {
          background: $color-split;
        }
      }
    }
  }
  .tool-model {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
  }
</style>